import React, { useState, useEffect, useRef, useMemo, Fragment } from "react";
import SVGInline from "react-svg-inline";
import BackArrow from "../../../../shared/assets/arrow-left.svg";
import CloseIcon from "../../../../shared/assets/x.svg";
import CalendarIcon from "../../../../shared/assets/calendar-drawers.svg";
import "./times-drawer.scss";
import moment from "moment";
import Modal from "../../../../shared/components/Modal";
import "../SkeletonDrawer/skeleton-drawer.scss";
import {
  AVAILABLE_APPOINTMENTS_ENDPOINT,
  AVAILABLE_MAMMO_APPOINTMENTS_ENDPOINT,
  MAMMO_VISIT_REGULAR,
} from "../../../../shared/constants/api-helpers";
import { fetchAPIData } from "../../../../shared/services/fetchData";
import { isOBGYN } from "../../../../shared/utility-functions/isOBGYN.js";
import SelectLocationBox from "../SelectLocationBox/index";
import arrowUp from "../../../../shared/assets/arrow-up.svg";
import arrowDown from "../../../../shared/assets/arrow-down.svg";
import { buildDoctorUrl } from "../../../../shared/utility-functions";
import { scheduleButtonEvent } from "../../../../shared/utility-functions/googleTagManager.js";
import locationPlaceholderSvg from "../../../../shared/assets/locationPlaceholder.svg";
import isDesktop from "../../../../shared/utility-functions/isDesktop.js";
import { obOnlineSchedulingConstants } from "../../SearchCards/SuperResultsCard/SuperResultsTimes/obOnlineSchedulingConstants.js";
import MobileTimesCompNew from "../../../../Profile/components/AvailableTimes/MobileTimesCompNew.jsx";
import isMobile from "../../../../shared/utility-functions/isMobile.js";
import { CannotSchedule } from "../../../../shared/components/CannotSchedule/CannotSchedule.jsx";

const TimesDrawer = ({
  isSchedule = false,
  provider = null,
  flow,
  locs,
  fadeOutType,
  onAnimationEnd,
  from,
  show,
  handleClose,
  handleCloseAll,
  scheduleLinkClick,
  obgynScheduleLinkClick,
  mamLocation = null,
  onMamTimeClick,
  headerContent,
  subHeaderContent,
  isModifySchedule,
  onSelectLocation,
  isShowAllLocationsView,
  initialSelectedLocation = null,
}) => {
  const [timesData, setTimesData] = useState(null);
  const [weeks, setWeeks] = useState(null);
  const [isLoadingNewLocation, setIsLoadingNewLocation] = useState(false);
  const [isLoadingScrollData, setIsLoadingScrollData] = useState(false);
  const [currentLastDate, setCurrentLastDate] = useState("");
  const [imageLoaded, setImageLoaded] = useState(false);
  const [newScheduleTime, setNewScheduleTime] = useState(null);
  const [selectedChipIdx, setSelectedChipIdx] = useState("");
  const [locations, setLocations] = useState([]);
  const [showSelectLocationBox, setShowSelectLocBox] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [data, setData] = useState(null)
  const containerRefs=useRef([])
  const [ghostCounts,setGhostCounts]=useState([]);

  const isSuperMammoScheduling = window.sessionStorage.getItem("isSuperMammoScheduling") || false;
  const isOBS = window.sessionStorage.getItem("isOBS") ? true : false;
  const isNotMobileOrProfie = !isMobile(window.innerWidth) || from !=='provider-profile';

  useEffect(() => {
    setNewScheduleTime(null);
    setSelectedChipIdx("");
  }, []);

  useEffect(() => {
    let locations = provider && provider.locations && provider.locations.length > 0 ? provider.locations : null;
    setLocations(locations);
  }, [provider]);

  useEffect(() => {
    if (from === 'provider-profile'){
      setLocations(locs);
    }
  }, [locs]);
 
  useEffect(() => {
    if (initialSelectedLocation && locations && locations.length > 0) {
      let matched = locations.find(
        loc => loc.departmentId === initialSelectedLocation.departmentId
      );
      if (!matched && (initialSelectedLocation.lat && initialSelectedLocation.lng) || (initialSelectedLocation.Latitude && initialSelectedLocation.Longitude)) {
        const lat = parseFloat(initialSelectedLocation.lat || initialSelectedLocation.Latitude);
        const lng = parseFloat(initialSelectedLocation.lng || initialSelectedLocation.Longitude);
        matched = locations.find(
          loc =>
            Math.abs(loc.latitude - lat) <= 0.03 &&
            Math.abs(loc.longitude - lng) <= 0.03
        );
      }
      if (matched) {
        setSelectedLocation(matched);
        return;
      }
    }

    let sessionSelectedLocation = window.sessionStorage.getItem('fadSelectedLocation');
    sessionSelectedLocation = sessionSelectedLocation ? JSON.parse(sessionSelectedLocation) : null;
    if (sessionSelectedLocation) {
      setSelectedLocation(sessionSelectedLocation)
    }
    else {
      const address = provider && provider.address ? provider.address : null;

      if (locations && locations.length > 0 && address !== null) {
        let primaryLocation = address.dpt ? locations.find(x => x.departmentId == address.dpt) : null;
        if (!primaryLocation) {
          for (let location of locations) {
            if (Math.abs(address.lat - location.latitude) <= 0.03 && Math.abs(address.lng - location.longitude) <= 0.03) {
              primaryLocation = location;
            }
          }
        }
        if (provider.doctorSelectedLocation) {
          setSelectedLocation(provider.doctorSelectedLocation);
        }
        else if (primaryLocation) {
          setSelectedLocation(primaryLocation);
        } else {
          setSelectedLocation(locations[0]);
        }
      }
    }
  }, [locations, provider]);



  useEffect(()=>{
    calculateGhostSlots()
    window.addEventListener('resize',calculateGhostSlots);
    return ()=>window.removeEventListener('resize',calculateGhostSlots);
  },[timesData])

  const calculateGhostSlots=()=>{   
    if(containerRefs.current.length==0) return;

    const counts=containerRefs.current.map((container)=>{
      if(!container) return 0;

      const children=Array.from(container.children).filter(child=>
        !child.classList.contains('ghost-slot')
      )
      if(children.length===0) return 0;
      const containerWidth=container.offsetWidth
      const totalColumns=Math.floor(containerWidth/90);
      const rows={};
      children.forEach((child)=>{
        const top=child.offsetTop;
        if(!rows[top]) rows[top]=[]
        rows[top].push(child);
      })
      const rowTops=Object.keys(rows).map(Number).sort((a,b)=>a-b)
      if(rowTops.length===0) return 0;
      const lastRowTop=rowTops[rowTops.length-1]
      const lastRowItems=rows[lastRowTop].length

      const missingSlots=totalColumns-lastRowItems
      return missingSlots>0?missingSlots:0
})
  
  setGhostCounts(counts)
}
  useEffect(() => {
  containerRefs.current.forEach((container) => {
    if (!container) return;
    const allChildren = Array.from(container.children);
    // Group children by their offsetTop (row)
    const rows = {};
    allChildren.forEach((child) => {
      const top = child.offsetTop;
      if (!rows[top]) rows[top] = [];
      rows[top].push(child);
    });
    const rowTops = Object.keys(rows).map(Number).sort((a, b) => a - b);
    if (rowTops.length === 0) return;
    const lastRowTop = rowTops[rowTops.length - 1];
    const lastRow = rows[lastRowTop];
    // If last row contains only ghost slots, remove them
    if (lastRow.length > 0 && lastRow.every(child => child.classList.contains('ghost-slot'))) {
      lastRow.forEach(child => container.removeChild(child));
    }
  });
});
    
  
  const timesDrawerRef = useRef();
  const maxMonthCount = 6; //matches the requirement that providers must have a first available time within the next 6 months
  const locationMonthSpan = 2;
  const maxInitialFetchTries = Math.ceil(maxMonthCount / locationMonthSpan);
  const today = moment();
  let maxEndDate = today.clone().add(maxMonthCount,"months");
  let initialStartDate = today.clone();
  let initialEndDate = today.clone().add(2, "months");
  
  if(maxEndDate.day() !== 0){
    const daysToAdd = 7 - maxEndDate.day();
     maxEndDate = maxEndDate.clone().add(daysToAdd, "days");
  }else{
     maxEndDate = maxEndDate.clone();
  }

  if (isSuperMammoScheduling && isModifySchedule) {
    const patientDob = moment(window.sessionStorage.getItem("qDate"));
    const diffYears = today.diff(patientDob, "years");
    const lastDob = patientDob.clone().add(diffYears, "years");
    const diffMonths = today.diff(lastDob, "months");
    if (diffYears == 39 && diffMonths == 11) {
      initialStartDate = patientDob.clone().add(40, "years");
      initialEndDate = initialStartDate.clone().add(2, "months");
    }
  }
  if (isOBS) {
    const currentDate = window.sessionStorage.getItem("scheduleDate") ? new Date(window.sessionStorage.getItem("scheduleDate")) : new Date();

    initialStartDate = moment(currentDate);
    initialEndDate = initialStartDate.clone().add(2, "months");
  }

  let initialStartDateString = initialStartDate.format("YYYY-MM-DD");
  let initialEndDateString = initialEndDate.format("YYYY-MM-DD");

  let baseParams = useMemo(() => {
    if (flow === "mam") {
      return {
        endPoint: AVAILABLE_MAMMO_APPOINTMENTS_ENDPOINT,
        startDate: null,
        endDate: null,
        visitTypeId: window.sessionStorage.getItem("VisitTypeID") || MAMMO_VISIT_REGULAR,
        locationId: mamLocation.Id,
        weekIdentifier: null,
      };
    } else {
      return {
        endPoint: AVAILABLE_APPOINTMENTS_ENDPOINT,
        schedulingType: "Open",
        startDate: null,
        endDate: null,
        physicianId: provider ? provider.epicId : null,
      };
    }
  }, [flow, provider, mamLocation]);

  const getTimesDataOnScroll = async (startDateStringParam, oneWeekAheadStringParam) => {
    setIsLoadingScrollData(true);
    let isFetchData = true;

    const params = {
      ...baseParams,
      startDate: startDateStringParam,
      endDate: oneWeekAheadStringParam,
      ...(flow === "mam" ? { locationId: mamLocation.Id } : { physicianId: provider.epicId }),
    };

    if (selectedLocation && selectedLocation.departmentId) {
      params.departmentId = selectedLocation.departmentId;
    }
    const visitTypeID = window.sessionStorage.getItem("visitTypeOBGYN");
    if (visitTypeID && isOBGYN(provider && provider.specialtyIds)) params.visitTypeId = visitTypeID;

    if (isOBS && isOBGYN(provider && provider.specialtyIds)) {
      const filteredData = obOnlineSchedulingConstants.find((it) => it.DepartmentId == params.departmentId && it.ProviderId == params.physicianId);
      if (filteredData !== undefined) {
        params.physicianId = filteredData.NurseId;
        params.visitTypeId = filteredData.VisitTypeID;
      } else {
        setIsLoadingScrollData(false);
        isFetchData = false;
        return;
      }
    }

    if (isFetchData) {
      try {
        const response = await fetchAPIData(params);
        setData(response)
        const uniqueMap = new Map(response.Dates.map((date) => [date.Date, date]));
        const uniqueTimes = Array.from(uniqueMap.values());
        timesData === null
          ? setTimesData(convertTimesData(uniqueTimes))
          : setTimesData((prevData) => [...prevData, ...convertTimesData(uniqueTimes)]);
        const weekList = createWeekList(startDateStringParam, oneWeekAheadStringParam);
        const lastWeekDate = weekList[weekList.length - 1].endOfWeek;
        setCurrentLastDate(moment(lastWeekDate).format("YYYY-MM-DD"));
        weeks === null ? setWeeks(weekList) : setWeeks((prevData) => [...prevData, ...weekList]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    setIsLoadingScrollData(false);
  };

  const getTimesDataOnLocationChange = async (startDateStringParam, oneMonthAheadStringParam) => {
    if(provider && !provider.hasScheduleOnline){
      setTimesData([]);
      setIsLoadingNewLocation(false);
      return ;
    }
    setIsLoadingNewLocation(true);
    let isFetchData = true;

    const params = {
      ...baseParams,
      startDate: startDateStringParam,
      endDate: oneMonthAheadStringParam,
      ...(flow === "mam" ? { locationId: mamLocation.Id } : { physicianId: provider.epicId }),
    };

    if (selectedLocation && selectedLocation.departmentId) {
      params.departmentId = selectedLocation.departmentId;
    }
    const visitTypeID = window.sessionStorage.getItem("visitTypeOBGYN");
    if (!isOBS && visitTypeID && isOBGYN(provider.specialtyIds)) params.visitTypeId = visitTypeID;

    if (isOBS && isOBGYN(provider.specialtyIds)) {
      const filteredData = obOnlineSchedulingConstants.find((it) => it.DepartmentId == params.departmentId && it.ProviderId == params.physicianId);
      if (filteredData !== undefined) {
        params.physicianId = filteredData.NurseId;
        params.visitTypeId = filteredData.VisitTypeID;
      } else {
        setIsLoadingNewLocation(false);
        isFetchData = false;
        return;
      }
    }

    if (isFetchData) {
      try {
        let fetchCount = 0;
        let response = await fetchAPIData(params);
        setData(response)
        while (!response || (response.Dates.length === 0 && fetchCount < maxInitialFetchTries)) {
          params.startDate = params.endDate;
          params.endDate = moment(params.endDate).clone().add(locationMonthSpan, "months").format("YYYY-MM-DD");
          response = await fetchAPIData(params);
          fetchCount++;
        }
        if(response.Dates.length === 0 && from === 'provider-profile') {
          setTimesData([]);
          setIsLoadingNewLocation(false);
          return;
        }
        const uniqueMap = new Map(Array.isArray(response.Dates) ? response.Dates.map((date) => [date.Date, date]) : []);
        const uniqueTimes = Array.from(uniqueMap.values());
        const createWeekListStartDate = response.Dates && response.Dates[0].Date;
        let createWeekListEndDate = params.endDate;
        if(createWeekListStartDate == createWeekListEndDate){
          createWeekListEndDate = moment(createWeekListEndDate).clone().add(locationMonthSpan, "months").format("YYYY-MM-DD");
        }
        const weekList = createWeekList(createWeekListStartDate, createWeekListEndDate);//response.Dates[response.Dates.length-1].Date
        const lastWeekDate = weekList[weekList.length - 1].endOfWeek;
        setCurrentLastDate(moment(lastWeekDate).format("YYYY-MM-DD"));
        setTimesData(convertTimesData(uniqueTimes));
        setWeeks(weekList);
      } catch (error) {
        setTimesData([]);
        setIsLoadingNewLocation(false);
        console.error("Error fetching data:", error);
      }
    }
    setIsLoadingNewLocation(false);
  };

  useEffect(() => {
    if (selectedLocation || mamLocation) getTimesDataOnLocationChange(initialStartDateString, initialEndDateString);
  }, [selectedLocation, mamLocation]);

  useEffect(() => {
    const handleClickOutsideDrawer = (event) => {
      if (timesDrawerRef.current && !timesDrawerRef.current.contains(event.target)) {
        handleCloseAll();
      }
    };

    document.addEventListener("mousedown", handleClickOutsideDrawer);

    return () => {
      document.removeEventListener("mousedown", handleClickOutsideDrawer);
    };
  }, [timesDrawerRef]);

  const handleInfiniteScroll = (event) => {
    if (isLoadingScrollData) return;

    const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
    const threshold = 3000;
    if (scrollHeight - scrollTop - clientHeight <= threshold) {
      let startDateObj = new Date(currentLastDate + "T00:00:00");
      startDateObj.setDate(startDateObj.getDate() + 1);
      let newEndDateObj = new Date(startDateObj);
      newEndDateObj.setDate(newEndDateObj.getDate() + 6); // + 1 week
      let startDateString = moment(startDateObj).format("YYYY-MM-DD");
      let oneWeekAheadString = moment(newEndDateObj).format("YYYY-MM-DD");

      if(moment(newEndDateObj).isBefore(maxEndDate)){
        setIsLoadingScrollData(true);
        getTimesDataOnScroll(startDateString, oneWeekAheadString);
      }
    }
  };

  const convertTimesData = (data) => {
    let convertedData = [];

    const convertToStandardTime = (timesList) => {
      return timesList.map((timeObj) => {
        let time = timeObj.Time;
        let [hours, minutes] = time.split(":").map(Number);

        let period = hours >= 12 ? "PM" : "AM";
        hours = hours % 12;
        if (hours === 0) {
          hours = 12;
        }
        minutes = minutes < 10 ? "0" + minutes : minutes;
        let standardTime = `${hours}:${minutes} ${period}`;
        return { ...timeObj, Time: standardTime };
      });
    };

    for (let dateTimeObj of data) {
      const newDate = new Date(dateTimeObj.Date + "T00:00:00");
      const convertedTimes = convertToStandardTime(dateTimeObj.Times);
      const newDateTimeObj = { Date: newDate, Times: convertedTimes };
      convertedData.push(newDateTimeObj);
    }

    return convertedData;
  };

  const createWeekList = (startDateString, endDateString) => {
    let startOfWeek = null;
    let endOfWeek = null;
    let weekList = [];
    let startDateObj = new Date(startDateString + "T00:00:00");
    let endDateObj = new Date(endDateString + "T00:00:00");
    const isWeekday = (dateObj) => {
      const dayOfWeek = dateObj.getDay();
      return dayOfWeek >= 1 && dayOfWeek <= 5;
    };
    const getNextMonday = (weekendDateObj) => {
      const newDate = new Date(weekendDateObj);
      const dayOfWeek = newDate.getDay();

      let daysToAdd = 0;
      if (dayOfWeek === 0) {
        daysToAdd = 1;
      } else if (dayOfWeek === 6) {
        daysToAdd = 2;
      }
      newDate.setDate(newDate.getDate() + daysToAdd);
      return newDate;
    };
    const getPreviousMonday = (weekdayDateObj) => {
      const newDate = new Date(weekdayDateObj);
      const dayOfWeek = newDate.getDay();

      let daysToSubtract = dayOfWeek - 1;

      newDate.setDate(newDate.getDate() - daysToSubtract);
      return newDate;
    };
    const getEndOfWeek = (startOfWeekObj) => {
      const newDate = new Date(startOfWeekObj);
      newDate.setDate(flow !== "mam" ? newDate.getDate() + 4 : newDate.getDate() + 6);
      return newDate;
    };
        while (startDateObj < endDateObj) {
      if (isWeekday(startDateObj)) {
        if (startDateObj.getDay() === 1) {
          // Monday
          startOfWeek = startDateObj;
          endOfWeek = getEndOfWeek(startOfWeek);
        } else {
          startOfWeek = getPreviousMonday(startDateObj);
          endOfWeek = getEndOfWeek(startOfWeek);
        }
      } else {
        startOfWeek = getNextMonday(startDateObj);
        endOfWeek = getEndOfWeek(startOfWeek);
      }
      let datesWithinWeek = [];
      for (let date = new Date(startOfWeek); date <= endOfWeek; date.setDate(date.getDate() + 1)) {
        datesWithinWeek.push({ Date: new Date(date) });
      }
      let newObj = { startOfWeek: startOfWeek, endOfWeek: endOfWeek, datesWithinWeek: datesWithinWeek };
      weekList.push(newObj);

      startDateObj = new Date(startOfWeek);
      startDateObj.setDate(startDateObj.getDate() + 7);
    }
    return weekList;
  };

const weekListByFirstAvailable = (weekList, timesData) => {
  const firstAvailableDayObj = timesData && timesData.length > 0
    ? timesData.find((day) => Array.isArray(day.Times) && day.Times.length > 0)
    : null;
  const firstAvailableDate = firstAvailableDayObj ? firstAvailableDayObj.Date : null;

  // Find the first week containing the first available appointment
  const firstAvailableWeekIndex = weekList.findIndex((week) =>
    week.datesWithinWeek.some((day) => isSameDate(day.Date, firstAvailableDate))
  );
  const newWeekList = weekList.slice(firstAvailableWeekIndex);

  // For the first week, only show days from the first available appointment onward
  let startIndex = 0;
  if (newWeekList.length > 0 && firstAvailableDate) {
    startIndex = newWeekList[0].datesWithinWeek.findIndex((day) =>
      isSameDate(day.Date, firstAvailableDate)
    );
    newWeekList[0].datesWithinWeek = newWeekList[0].datesWithinWeek.slice(startIndex);
  }
  return newWeekList;
};
  

  const isSameDate = (date1, date2) => {
    return date1.getDate() === date2.getDate() && date1.getMonth() === date2.getMonth() && date1.getFullYear() === date2.getFullYear();
  };

  const hasAvailableAppointments = (day) => {
    const timesDataDate = timesData.find(
      (data) => data.Date.getDate() === day.getDate() && data.Date.getMonth() === day.getMonth() && data.Date.getFullYear() === day.getFullYear()
    );

    return timesDataDate ? true : false;
  };

  const onProviderTimeClick = (provider, date, time) => {
    const dataLayerObject = {
      flow: flow,
      providerName: provider ? provider.title : "",
      providerID: provider ? provider.id : null,
      providerNPI: provider ? provider.npi : null,
      providerSpecialty: provider && provider.specialties ? provider.specialties.join(", ") : undefined,
      facilityName: undefined,
      facilityAddress: undefined,
    };

    scheduleButtonEvent(dataLayerObject);
    const openSchedulingURL = provider ? buildDoctorUrl("/schedule/", { name: provider.title, npi: provider.npi }) : null;

    const location = provider && provider.locations.find((loc) => loc.departmentId === time.DepartmentId);
    sessionStorage.setItem("fadSelectedLocation", JSON.stringify(location));
    setSelectedLocation(location)

    let convertedTime = {
      DepartmentId: time.DepartmentId,
      Duration: time.Duration,
      Time: time.Time,
    };
    let newTime = moment(convertedTime.Time, "hh:mm a").format("HH:mm");
    convertedTime.Time = newTime;

    const appointment = {
      Date: date,
      Time: convertedTime,
    };
    sessionStorage.setItem("fadSelectedAppointment", JSON.stringify(appointment));
    sessionStorage.setItem("fadSelectedDoctor", JSON.stringify(provider));
    sessionStorage.setItem("search-path", window.location.href);
    if (from !== "date-time-details" && isOBGYN(provider.specialtyIds)){
      window.location.href = openSchedulingURL;
    }
    else{
      scheduleLinkClick(openSchedulingURL);
    }

    if (isOBGYN(provider.specialtyIds)) {
      obgynScheduleLinkClick(openSchedulingURL, provider.phone, provider);
    } 
    else {scheduleLinkClick(openSchedulingURL)}
    handleCloseAll();
  };

  let customClass = "bg-over-drawer";
  if (from === "card") {
    customClass = `${customClass} animate-in-slide`;
  }
  if (flow === "mam") {
    customClass = `${customClass} mam-background`;
  }
  if (fadeOutType === "times") {
    customClass = `${customClass} animate-out`;
  } else if (fadeOutType === "all") {
    customClass = `${customClass} animate-out-all-top`;
  }

  const getFirstAndLastOpenDays = () => {
    const daysOfWeek = [
      { OpenMon: "Monday" },
      { OpenTue: "Tuesday" },
      { OpenWed: "Wednesday" },
      { OpenThu: "Thursday" },
      { OpenFri: "Friday" },
      { OpenSat: "Saturday" },
      { OpenSun: "Sunday" },
    ];

    let firstOpenDay = null;
    let lastOpenDay = null;

    for (let dayObj of daysOfWeek) {
      const [key, value] = Object.entries(dayObj)[0];
      if (mamLocation[key]) {
        if (firstOpenDay === null) {
          firstOpenDay = value;
        }
        lastOpenDay = value;
      }
    }

    if (firstOpenDay && lastOpenDay) {
      return `Open ${firstOpenDay} - ${lastOpenDay}`;
    } else {
      return null;
    }
  };

  const checkImageLoad = (src, onSuccess, onError) => {
    const img = new Image();
    img.onload = onSuccess;
    img.onerror = onError;
    img.src = src;
  };

  useEffect(() => {
    if (flow === "mam") {
      if (mamLocation && mamLocation.LandscapePhotoURL) {
        checkImageLoad(
          mamLocation.LandscapePhotoURL,
          () => setImageLoaded(true),
          () => setImageLoaded(false)
        );
      } else {
        setImageLoaded(false);
      }
    }
  }, [flow, mamLocation]);

  const validateOrgUnit = () => {
    return provider.OrganizationalUnit.find(org => org.Name.includes('Primary Care')) ? true : false;
  }
  const canChangeLocation = !isShowAllLocationsView;
  
  return (
    <span
      className='skeleton-drawer-outer'
      style={{ display: "block" }}
      onAnimationEnd={() => {
        onAnimationEnd();
      }}>
      <Modal
        showModal={show}
        hideCloseButton
        hideFunction={handleClose}
        customClass={customClass}
        flow={flow}>
        <div
          onScroll={(e) => ((!isModifySchedule && isNotMobileOrProfie)  ? handleInfiniteScroll(e) : null)}
          className='times-drawer-container'
          ref={timesDrawerRef}>
          {flow !== "mam" ? (
            !isMobile(window.innerWidth) && 
            <div className='blue-rectangle'>
              <div className='close-buttons'>
                <div
                  className='back-to-profile'
                  onClick={handleClose}>
                  <SVGInline
                    className='back-arrow'
                    svg={BackArrow}
                  />
                  <span className='back-to-profile-text'>Profile</span>
                </div>

                <div
                  className='close-all'
                  onClick={handleCloseAll}>
                  <SVGInline
                     className="close-all-x white-icon"
                    svg={CloseIcon}
                  />
                </div>
              </div>
            </div>
          ) : (
            isDesktop(window.innerWidth) && (
              <React.Fragment>
                <div className='mam-location-image--container'>
                  <div
                    className={`mam-close-all ${!imageLoaded ? "no-image-found" : ""}`}
                    onClick={handleCloseAll}>
                    <SVGInline
                      className='close-all-x mam-icon'
                      svg={CloseIcon}
                    />
                  </div>
                  {imageLoaded ? (
                    <img
                      alt={mamLocation.Name}
                      src={mamLocation.LandscapePhotoURL}
                      aria-label={mamLocation.Name}
                      className='mam-location-image--url'
                    />
                  ) : (
                    <SVGInline
                      className='mam-location-placeholder-image'
                      svg={locationPlaceholderSvg}
                    />
                  )}
                </div>
                <div className='mam-location-details--container'>
                  <div className='mam-location-name'>{mamLocation.Name}</div>
                  <div className='mam-location-address'>
                    {mamLocation.Distance != null ? `${mamLocation.Distance} mi - ` : ""} {mamLocation.Address}, {mamLocation.City}
                  </div>
                  <div className='mam-location-days'>{getFirstAndLastOpenDays()}</div>
                  <div className='mam-location-phone'>{mamLocation.Phone}</div>
                </div>
                <hr className='mam-location-divider' />
              </React.Fragment>
            )
          )}

          {isDesktop(window.innerWidth) ? (
            <div className='avail-times-header'>{headerContent}</div>
          ) : (
            <div className='avail-times-header'>
              {" "}
              {headerContent}{" "}
              <div
                className={`mam-close-all ${!imageLoaded && flow === "mam" ? "no-image-found" : ""}`}
                onClick={handleCloseAll}>
                <SVGInline
                  className='close-all-x'
                  svg={CloseIcon}
                />
              </div>
            </div>
          )}
          <div className={`avail-times-sub-header ${!subHeaderContent ? "d-none" : ""}`}>{subHeaderContent}</div>
          {locations && locations.length > 0 && provider.hasScheduleOnline && selectedLocation ? (
                  <div className='location-holder'>
                    <div className='available-times-location-label name'>{selectedLocation.departmentName || ''}</div>
                    <div className='available-times-location-label street'>
                      {selectedLocation.address.street || ''}, {selectedLocation.address.cityStateZip.split(",")[0] || ''}
                    </div>
                  </div>
                ) : null}

          {flow === 'mam' || (provider && provider.hasScheduleOnline) ?
            <Fragment>
              <div>
                {canChangeLocation && locations && locations.length > 1 ? (
                  <div
                    className=' clickable mb-16 change-location-container'
                    onClick={() => {
                      setShowSelectLocBox(!showSelectLocationBox);
                    }}>
                    <a className='clickable available-times-location-label change'>Change Location</a>
                    {showSelectLocationBox ? (
                      <SVGInline
                        className='dropdown-arrow'
                        svg={arrowUp}
                      />
                    ) : (
                      <SVGInline
                        className='dropdown-arrow'
                        svg={arrowDown}
                      />
                    )}
                  </div>
                ) : null}
                {selectedLocation && selectedLocation != undefined ? <SelectLocationBox
                  selected={selectedLocation}
                  setShowSelectLocBox={() => setShowSelectLocBox(!showSelectLocationBox)}
                  hasScheduleOnline={provider ? provider.hasScheduleOnline : null}
                  setLocation={(newLoc) => {
                    if (newLoc) {
                      setSelectedLocation(newLoc);
                      if (from === 'provider-profile') {
                        onSelectLocation(newLoc);
                      }
                    }
                  }}
                  show={showSelectLocationBox}
                  locationList={locations}
                  disabled={!canChangeLocation}
                /> : null}
              </div>
              {
                (!timesData || timesData.length === 0) && !isLoadingNewLocation ?
                  (<div>
                    {
                      provider ?
                        <Fragment>
                          <CannotSchedule
                            page={'times-drawer'}
                            fetchFailed={true}
                            provider={provider}
                            superLocationCardAltLocationPhone={provider.phone}
                            from={from}
                          />
                          <div className='cannot-schedule-phone-container'>
                            {!isDesktop(window.innerWidth) ?
                              <a href={`tel:${provider.phone}`}>{provider.phone}</a>
                              : provider.phone
                            }
                          </div>
                          <div className='search-provider'> 
                            <a onClick={() => window.history.back()}>Search for another provider</a>
                          </div>
                        </Fragment>
                        : null
                    }
                  </div>) :
                  (<div
                    className='avail-times-section'
                    onScroll={(e) => ((isModifySchedule && isNotMobileOrProfie) ? handleInfiniteScroll(e) : null)}>
                    {(isNotMobileOrProfie ?
                      timesData && weeks &&
                      !isLoadingNewLocation &&
                      weekListByFirstAvailable(weeks, timesData).map((week, index) => {
                        return (
                          <div key={index}>
                            {week.datesWithinWeek.map((date, index) => {
                              let dayName = date.Date.toLocaleString("en-US", { weekday: "long" });
                              let monthName = date.Date.toLocaleString("default", { month: "long" });
                              let newDate = date.Date.getDate();
                              let dayHasAvailableAppointments = timesData.find((x) => isSameDate(date.Date, x.Date) && x.Times && x.Times.length > 0);
                              return (
                                <div key={index}>
                                  <div className='day-heading'>
                                    {dayName}, {monthName} {newDate}
                                  </div>
                                  {dayHasAvailableAppointments ? (
                                    <div>
                                      {timesData.map((day, timesDataIndex) => {
                                        if (isSameDate(day.Date, date.Date)) {
                                          return (
                                            <div ref={(el)=>{containerRefs.current[timesDataIndex]=el}}
                                              key={timesDataIndex}
                                              className={`time-slot-container ${flow === "mam" && !isDesktop(window.innerWidth) ? "mam-time-slot-container-mobile" : ""
                                                }`}>
                                              {day.Times.map((time, index) => (
                                                <div
                                                  key={index}
                                                  className={`time-slot-chip-drawer ${selectedChipIdx == `${timesDataIndex}::${index}` ? "selected-time" : ""
                                                    }`}
                                                  onClick={() => {
                                                    setSelectedChipIdx(`${timesDataIndex}::${index}`);
                                                    setNewScheduleTime({ date: day.Date, time, provider });
                                                    flow === "mam" ? onMamTimeClick(day.Date, time) : onProviderTimeClick(provider, day.Date, time);
                                                  }}>
                                                  {time.Time}
                                                </div>
                                              ))}
                                              {Array.from({length:ghostCounts[timesDataIndex]||0}).map((_,index)=>(
                                                <div key={`ghost-${index}`} className="time-slot-chip-drawer ghost-slot"/>
                                              ))}
                                            </div>
                                          );
                                        }
                                      })}
                                    </div>
                                  ) : (
                                    <div className='no-avail-times'>
                                      <div className=''>
                                        <SVGInline
                                          className='no-avail-times-calendar'
                                          svg={CalendarIcon}
                                        />
                                      </div>
                                      <p>No available appointment times.</p>
                                    </div>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        );
                      })
                      :
                      <div className="mobile-times">
                        <MobileTimesCompNew data={data} getTimesDataOnScroll={getTimesDataOnScroll} selectedLocation={selectedLocation} isLoadingNewLocation={isLoadingNewLocation} onProviderTimeClick={onProviderTimeClick} provider={provider} />
                      </div>
                    )
                    }
                    {(isLoadingScrollData || isLoadingNewLocation) &&
                      isNotMobileOrProfie &&
                      <div className='skeleton'>
                        <div className='grey-box' />
                      </div>
                    }
                  </div>)
              }
            </Fragment>
            :
            <Fragment>
              <CannotSchedule
                page={'profile-page'}
                fetchFailed={true}
                provider={provider}
                from={'provider-profile'}
              />
              <div className='cannot-schedule-phone-container'>
                {!isDesktop(window.innerWidth) ?
                  <a href={`tel:${provider.phone}`}>{provider.phone}</a>
                  : provider.phone
                }
              </div>
              <div className='search-provider'> 
                <a onClick={() => window.history.back()}>Search for another provider</a>
              </div>
            </Fragment>
          }
          {isSchedule ? (
            <div className='schdule-update-time-btn-container'>
              <button
                className='btn-cancel'
                onClick={handleCloseAll}>
                Cancel
              </button>
              <div className='flex-grow-1' />
              <button
                className='btn-update'
                onClick={() => {
                  onMamTimeClick(newScheduleTime.date, newScheduleTime.time, isSchedule);
                }}
                disabled={newScheduleTime ? false : true}>
                Update
              </button>
            </div>
          ) : null}
        </div>
      </Modal>
    </span>
  );
};

export default TimesDrawer; 
